// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".landing__content[data-v-29d2d6e7]{margin-top:54px}.landing__seo h3[data-v-29d2d6e7]{font-size:30px;font-weight:700;line-height:49px;margin-bottom:40px}.landing__seo-content[data-v-29d2d6e7]{font-size:16px;font-weight:400;line-height:22px;margin-bottom:120px}", ""]);
// Exports
module.exports = exports;
